import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 69.16 55.324',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2" transform="translate(0 -0.032)">
        <path
          fill={fill}
          d="M65.7,160H47.223l13,12.994a6.916,6.916,0,0,1,2.024,4.891v8.05a1.729,1.729,0,0,1-1.729,1.729H28.528a.864.864,0,0,1-.865-.864V185.07a.864.864,0,0,1,.865-.864H46.143l-6.916-6.916h-10.7a.864.864,0,0,1-.865-.864V174.7a.864.864,0,0,1,.865-.864h7.24L21.937,160H3.458A3.458,3.458,0,0,0,0,163.458V194.58a3.458,3.458,0,0,0,3.458,3.458H65.7a3.458,3.458,0,0,0,3.458-3.458V163.458A3.458,3.458,0,0,0,65.7,160ZM15.561,187.648v1.745a.864.864,0,0,1-.864.864H12.967a.864.864,0,0,1-.864-.864v-1.764a6.194,6.194,0,0,1-3.39-1.226.865.865,0,0,1-.062-1.312l1.27-1.209a.885.885,0,0,1,1.095-.079,2.6,2.6,0,0,0,1.385.4h3.038a1.359,1.359,0,0,0,1.275-1.425,1.411,1.411,0,0,0-.948-1.376L10.9,179.946a4.895,4.895,0,0,1-3.413-4.692,4.812,4.812,0,0,1,4.611-4.87v-1.739a.864.864,0,0,1,.864-.864H14.7a.864.864,0,0,1,.865.864v1.76a6.178,6.178,0,0,1,3.39,1.227.865.865,0,0,1,.151,1.212.786.786,0,0,1-.09.1l-1.27,1.212a.888.888,0,0,1-1.095.079,2.594,2.594,0,0,0-1.385-.4H12.224a1.359,1.359,0,0,0-1.275,1.425,1.411,1.411,0,0,0,.948,1.376l4.863,1.459a4.891,4.891,0,0,1,3.413,4.689,4.811,4.811,0,0,1-4.611,4.867Z"
          opacity="0.5"
          transform="translate(0 -142.681)"
        />
        <path
          fill={fill}
          d="M87.641.785a2.6,2.6,0,0,0-3.663,0L79.884,4.874a2.594,2.594,0,0,0,0,3.653l4.528,4.528L92.16,5.3Zm31.971,31.973L94.6,7.749,86.852,15.5l25.006,25.012a3.458,3.458,0,0,0,2.444,1.016h4.593a1.729,1.729,0,0,0,1.729-1.729V35.2A3.458,3.458,0,0,0,119.612,32.758ZM78.6,35.407l-4.863-1.459a1.411,1.411,0,0,1-.948-1.376,1.359,1.359,0,0,1,1.275-1.425H77.1a2.594,2.594,0,0,1,1.385.4.888.888,0,0,0,1.095-.079l1.27-1.212a.784.784,0,0,0,.09-.1.865.865,0,0,0-.151-1.212A6.178,6.178,0,0,0,77.4,27.721V25.964a.864.864,0,0,0-.864-.865H74.806a.864.864,0,0,0-.864.865v1.742a4.812,4.812,0,0,0-4.611,4.87,4.889,4.889,0,0,0,3.413,4.689l4.863,1.459a1.411,1.411,0,0,1,.948,1.376,1.359,1.359,0,0,1-1.275,1.425H74.239a2.6,2.6,0,0,1-1.385-.4.885.885,0,0,0-1.095.079L70.49,42.41a.865.865,0,0,0,.062,1.312,6.194,6.194,0,0,0,3.39,1.227v1.764a.864.864,0,0,0,.864.865h1.729a.864.864,0,0,0,.864-.865V44.966A4.811,4.811,0,0,0,82.01,40.1,4.893,4.893,0,0,0,78.6,35.407Z"
          transform="translate(-61.838 0)"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
